import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import moment from "moment/moment";
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
import IconButton from "@material-ui/core/IconButton";
import BackLink from "../../HelperComponents/BackLink/BackLink";
import DefaultButton from "../../Buttons/DefaultButton/DefaultButton";
import DialogComponent from "../../HelperComponents/DialogComponent/DialogComponent";
import TransitionedBlock from "../../HelperComponents/TransitionedBlock/TransitionedBlock";
import Loader from "../../HelperComponents/Loader/Loader";
import StatusDot from "../../HelperComponents/StatusDot/StatusDot";

import {
  getSpecificRefundRequest,
  patchRefundRequestStatus,
  postRefundRequestConfirmStatus,
  postDialogMessage,
  postRefundRequestOffers,
} from "../../../actions/refundRequestsActions";
import {
  getStatusRefundRequest,
  getStatusColor,
  formatPrice,
  getPositionStatusColor,
} from "../../../helpers/functions";

import CloseDialogIcon from "../../../assets/image/Mask.png";
import TelegramIcon from "../../../assets/image/telegram.png";
import ViberIcon from "../../../assets/image/viber.png";
import WhatsappIcon from "../../../assets/image/whatsapp.png";
import "./RefundRequestsItems.scss";
import CommentComponent from "../../HelperComponents/CommentComponent/CommentComponent";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import Button from '@material-ui/core/Button';
import UploadFile from "../../HelperComponents/UploadFile/UploadFile";
import { withUploadFile } from "../../../hocs/withUploadFile";
import RefundRequestsStatusForm from '../RefundRequestsStatusForm/RefundRequestsStatusForm';
import RefundRequestsStatusWholesaleForm from "../RefundRequestsStatusForm/RefundRequestsStatusWholesaleForm";
import AcceptProductDialog from "./AcceptProductDialog/AcceptProductDialog";
import AcceptProductStickerPrintButton from "./AcceptProductDialog/AcceptProductStickerPrintButton";

const STICKER_POSITION_STATUSES = ["На возврат", "Недовоз"];

class RefundRequestsItems extends Component {
  state = {
    loading: true,
    open: false,
    openDialog: false,
    id: null,
    loadingBtn: false,
    message: "",
    sendMessageLoading: false,
    files: null,
    highlightArticle: null,
    highlightOrder: null,
    highlightDispatchId: null,
    acceptProduct: null,
  };

  componentDidMount = () => {
    this.doRequest();
    const params = new URLSearchParams(this.props.location.search);
    const highlightArticle = params.get('highlightArticle');
    const highlightOrder = params.get('highlightOrder');
    const highlightDispatchId = params.get('highlightDispatchId');
    if (highlightArticle) {
      this.setState({
        highlightArticle,
        highlightOrder,
        highlightDispatchId: highlightDispatchId ? Number(highlightDispatchId) : null,
      });
      setTimeout(() => {
        this.setState({ highlightArticle: null, highlightOrder: null, highlightDispatchId: null });
      }, 3000);
    }
  };

  isHighlighted = (product) => {
    const { highlightArticle, highlightOrder, highlightDispatchId } = this.state;
    return highlightArticle
      && product.article_number === highlightArticle
      && String(product.ordernum) === String(highlightOrder)
      && (!highlightDispatchId || (product.dispatch_ids && product.dispatch_ids.includes(highlightDispatchId)));
  };

  doRequest = () => {
    const {
      match: { params },
      getSpecificRefundRequest,
    } = this.props;
    getSpecificRefundRequest(params.id).then((res) => {
      if (res.payload && res.payload.status && res.payload.status === 200) {
        this.setState({
          loading: false,
          id: res.payload.data.id,
        });
      } else {
        const backPath = this.props.backPath || '/admin/refund-requests-supplier';
        this.props.history.push({
          pathname: backPath,
          state: {
            isVsibleSnackBar: true,
            snackBarMessage: 'При получении данных по заявке на возврат возникла ошибка. Повторите попытку позже',
          }});
        }
    });
  };

  toggleDialog = () => {
    this.setState(({ open }) => ({
      open: !open,
    }));
  };

  toggleDialogOpen = () => {
    this.setState(({ openDialog }) => ({
      openDialog: !openDialog,
    }));
  };

  handleDialog = (status, { date, number, upd_number, upd_date, offers, invoice_number, invoice_date } = {} ) => {
    const {
      match: { params },
      patchRefundRequestStatus,
      refund_requests: { refund_request },
      postRefundRequestConfirmStatus,
      postRefundRequestOffers
    } = this.props;
    const data = { status: status, invoice_number, invoice_date };

    const companyRole = refund_request.companies_info ? refund_request.companies_info[0].company_role : refund_request.company_role;

    this.setState({
      open: false,
      openDialog: false,
      loading: true,
    });

    if (status === 'complete' && companyRole !== 'wholesale_customer') {
      this.setState({ loadingBtn: true });
      postRefundRequestConfirmStatus(params.id, { date, number, upd_number, upd_date }).then((res) => {
        this.setState({ loadingBtn: false });
        if (res.payload && res.payload.status) {
          this.doRequest();
        }
      });
    } else if (status === 'completeByPriceList' && companyRole !== 'wholesale_customer') {
      this.setState({ loadingBtn: true });
      postRefundRequestOffers(params.id, offers).then((res) => {
        this.setState({ loadingBtn: false });
        if (res.payload && res.payload.status) {
          this.doRequest();
        }
      });
    } else {
      patchRefundRequestStatus(params.id, data).then((res) => {
        this.setState({ loadingBtn: false });
        if (res.payload && res.payload.status) {
          this.doRequest();
        }
      });
    }
  };

  downloadFile = (file) => {
    if (window.location.host !== "admin.mexcar.ru") {
      window.open(`https://api.testmexcar.ru${file}`);
    } else {
      window.open(`https://api.mexcar.ru${file}`);
    }
  };

  handleChangeTextarea = (e) => {
    this.setState({ message: e.target.value });
  };

  uploadFile = (files) => {
    this.setState({
      files,
    });
  };

  sendMessage = (messageText = null, files = null, parentMessageId = null, loadingKey = 'sendMessageLoading') => {
    const { postDialogMessage } = this.props;
    const { formData, setFromData } = this.props.withUploadFile;
    const {
      match: { params },
    } = this.props;
    
    const text = messageText || this.state.message;
    const fileData = files || this.state.files;
    
    this.setState({ [loadingKey]: true });
    
    setFromData(+params.id, text, fileData, parentMessageId);
    
    postDialogMessage(formData)
      .then((res) => {
        if (parentMessageId) {
          this.setState({ 
            [`reply_${parentMessageId}`]: '', 
            [`replyFiles_${parentMessageId}`]: null, 
            [loadingKey]: false, 
            [`showReplyForm_${parentMessageId}`]: false 
          });
        } else {
          this.setState({ [loadingKey]: false, message: "", files: null });
        }
        this.doRequest();
      })
      .catch(() => {
        this.setState({ [loadingKey]: false });
      });
  };

  hasFiles() {
    const {
      refund_requests: { refund_request }
    } = this.props;

    let files = 0

     refund_request && 
     refund_request.messages && 
     refund_request.messages.length && 
     refund_request.messages.forEach(element => element.files.length && files++);

    return !!files
  }

  render() {
    const {
      refund_requests: { refund_request },
    } = this.props;
    const {
      loading,
      open,
      openDialog,
      loadingBtn,
      message,
      sendMessageLoading,
    } = this.state;

    if (loading) return <Loader />;

    const orderNumbers = Array.isArray(refund_request.ordernum)
      ? refund_request.ordernum.join(', ')
      : refund_request.ordernum;

    const documentNumber = refund_request.document_number || refund_request.upd_number ;
    const companyRole = refund_request.companies_info ? refund_request.companies_info[0].company_role : refund_request.company_role;

    return (
      <TransitionedBlock>
        <div className="item_page container">
          <div className="flex-center-btw title-block-page">
            <div className="title-page">
              <BackLink />
              {documentNumber ?  <h1>Заявка на возврат по номеру {documentNumber}</h1> : <h1>Заявка на возврат к заказу {orderNumbers}</h1>}
            </div>
          </div>
          <div className="item_page_block">
            <div className="block_wrapper status_wrapper">
              <div className="title_items">Статус заказа</div>
              {refund_request.status !== "processing" ? (
                <div>
                  <div className="descriptions_items">Статус</div>
                  <div className="title_items_mini block_status_info indent_none">
                    <span
                      className="status"
                      style={{
                        background: `${getStatusColor(refund_request.status)}`,
                      }}
                    />
                    {getStatusRefundRequest(refund_request.status)}
                  </div>
                  {
                    refund_request.status === "waiting_for_documents" &&
                      <div className="wrapper_btn_items mt-20">
                        <DefaultButton
                          variant="outlined"
                          classes="waiting_for_details"
                          onClick={() => {
                            this.setState({ loadingBtn: true });
                            this.handleDialog("waiting_for_details");
                            this.setState({ loadingBtn: false });
                          }}
                          loading={loadingBtn}
                          disabled={loadingBtn}
                        >
                          Ожидаем деталь
                        </DefaultButton>
                        <DefaultButton
                          variant="outlined"
                          classes="delete_btn"
                          onClick={this.toggleDialog}
                        >
                          Отказать
                        </DefaultButton>
                        <DefaultButton
                          classes="default_button_contained_green"
                          onClick={this.toggleDialogOpen}
                        >
                          Одобрить
                        </DefaultButton>
                      </div>
                  }
                  {
                    refund_request.status === "waiting_for_details" &&
                      <div className="wrapper_btn_items mt-20">
                        <DefaultButton
                          variant="outlined"
                          classes="waiting_for_documents"
                          onClick={() => {
                            this.setState({ loadingBtn: true });
                            this.handleDialog("waiting_for_documents");
                            this.setState({ loadingBtn: false });
                          }}
                          loading={loadingBtn}
                          disabled={loadingBtn}
                        >
                          Ожидаем документы
                          </DefaultButton>
                          <DefaultButton
                            variant="outlined"
                            classes="delete_btn"
                            onClick={this.toggleDialog}
                          >
                            Отказать
                        </DefaultButton>
                        <DefaultButton
                          classes="default_button_contained_green"
                          onClick={this.toggleDialogOpen}
                        >
                          Одобрить
                        </DefaultButton>
                      </div>
                  }
                  {
                    refund_request.status === "details_received" &&
                      <div className="wrapper_btn_items mt-20">
                        <DefaultButton
                          variant="outlined"
                          classes="delete_btn"
                          onClick={this.toggleDialog}
                        >
                          Отказать
                        </DefaultButton>
                      </div>
                  }
                </div>
              ) : (
                <div className="wrapper_btn_items">
                  <DefaultButton
                    variant="outlined"
                    classes="waiting_for_documents"
                    onClick={() => {
                      this.setState({ loadingBtn: true });
                      this.handleDialog("waiting_for_documents");
                      this.setState({ loadingBtn: false });
                    }}
                    loading={loadingBtn}
                    disabled={loadingBtn}
                  >
                    Ожидаем документы
                  </DefaultButton>
                  <DefaultButton
                    variant="outlined"
                    classes="waiting_for_details"
                    onClick={() => {
                      this.setState({ loadingBtn: true });
                      this.handleDialog("waiting_for_details");
                      this.setState({ loadingBtn: false });
                    }}
                    loading={loadingBtn}
                    disabled={loadingBtn}
                  >
                    Ожидаем деталь
                  </DefaultButton>
                  <DefaultButton
                    variant="outlined"
                    classes="delete_btn"
                    onClick={this.toggleDialog}
                  >
                    Отказать
                  </DefaultButton>
                  <DefaultButton
                    classes="default_button_contained_green"
                    onClick={this.toggleDialogOpen}
                  >
                    Одобрить
                    </DefaultButton>
                </div>
              )}
            </div>
            <div className="line_wrapper" />
            <div className="block_wrapper">
              <div className="title_items">Информация о документе</div>
              <div className="half_block_wrapper_items">
                {
                  refund_request && refund_request.document !== null
                    ?
                    (
                      <div>
                        <div className="descriptions_items">Номер</div>
                        <div className="title_items_mini">
                          {refund_request && refund_request.document && refund_request.document.number}
                        </div>
                        <div className="descriptions_items">Дата</div>
                        <div className="title_items_mini">
                          {
                            refund_request
                            && refund_request.document
                            && refund_request.document.date
                            && moment(refund_request.document.date).format('DD.MM.YYYY HH:mm')
                          }
                        </div>
                        {
                          (refund_request.document.upd_number || refund_request.document.invoice_number) &&
                          <>
                            <div className="descriptions_items">Номер выдачи/УПД</div>
                            <div className="title_items_mini">
                              {refund_request.document.upd_number || refund_request.document.invoice_number}
                            </div>
                          </>
                        }
                      </div>
                    )
                    :
                    (
                      <div>
                        <div className="title_items_mini">Информация не найдена</div>
                      </div>
                    )
                }
              </div>
            </div>
            <div className="line_wrapper" />
            <div className="block_wrapper">
              <div className="title_items">Информация о компаниях</div>
              {Array.isArray(refund_request.companies_info) && refund_request.companies_info.length > 0 ? (
                <div className="table_companies_wrapper">
                  <table className="companies_table">
                    <thead>
                      <tr>
                        <th>Название</th>
                        <th>Электронный адрес</th>
                        <th>Телефоны</th>
                      </tr>
                    </thead>
                    <tbody>
                      {refund_request.companies_info.map((company, idx) => (
                        <tr key={idx}>
                          <td>{company.company}</td>
                          <td>{company.company_email}</td>
                          <td>
                            {company.phones && company.phones.map((phone, idPhone) => (
                              <div key={idPhone} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                                {phone.phone_number}
                                <div className="info-social-wrapper">
                                  {!!phone.telegram && <img width={20} src={TelegramIcon} alt="telegram icon" />}
                                  {!!phone.viber && <img width={20} src={ViberIcon} alt="viber icon" />}
                                  {!!phone.whats_app && <img width={20} src={WhatsappIcon} alt="whatsapp icon" />}
                                </div>
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="table_companies_wrapper">
                  <table className="companies_table">
                    <thead>
                      <tr>
                        <th>Название</th>
                        <th>Электронный адрес</th>
                        <th>Телефоны</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{refund_request.company}</td>
                        <td>{refund_request.company_email}</td>
                        <td>
                          {refund_request.phones && refund_request.phones.map((phone, idPhone) => (
                            <div key={idPhone} style={{ display: 'flex', alignItems: 'center', gap: 4 }}>
                              {phone.phone_number}
                              <div className="info-social-wrapper">
                                {!!phone.telegram && <img src={TelegramIcon} alt="telegram icon" />}
                                {!!phone.viber && <img src={ViberIcon} alt="viber icon" />}
                                {!!phone.whats_app && <img src={WhatsappIcon} alt="whatsapp icon" />}
                              </div>
                            </div>
                          ))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              )}
            </div>
            <div className="line_wrapper" />
            <div className="block_wrapper">
            <div className="title_items">Сведения о товарах</div>
            {refund_request.product_info && Array.isArray(refund_request.product_info) && (
              <div className="table_products_wrapper">
                <table className="products_table">
                  <thead>
                    <tr>
                      <th>Компания</th>
                      <th>Номер заказа</th>
                      <th>Название</th>
                      <th>Артикул</th>
                      <th>Производитель</th>
                      <th>Количество</th>
                      <th>Сумма</th>
                      <th>Оригинальная цена</th>
                      <th>Компания поставщик</th>
                      <th>Номера выдачи/поступления</th>
                      {companyRole === 'wholesale_customer' && <th>Статус позиции</th>}
                    </tr>
                  </thead>
                  <tbody>
                    {refund_request.product_info.map((product, idx) => (
                      <tr key={idx} className={this.isHighlighted(product) ? 'highlighted_row' : ''}>
                        <td>{product.user}</td>
                        <td>{product.ordernum}</td>
                        <td>{product.name}</td>
                        <td>{product.article_number}</td>
                        <td>{product.producer}</td>
                        <td>{product.amount}</td>
                        <td>{formatPrice(product.price)}</td>
                        <td>{(product.original_price || product.original_price === 0) ? formatPrice(product.original_price) : ''}</td>
                        <td>{product.supplier_company || ''}</td>
                        <td>
                          {product.residues && product.residues.length > 0 && (
                            <div>
                              {product.residues.map((residue, i) => (
                                <div key={i}>
                                  {residue.document_number} - {residue.amount} шт., {moment(residue.date).format("DD.MM.YYYY")}
                                </div>
                              ))}
                            </div>
                          )}
                        </td>
                        {companyRole === 'wholesale_customer' && (
                          <td>
                            <div className="status_cell">
                              {product.position_status === 'Ожидает обработки' ? (
                                <DefaultButton
                                  size="small"
                                  onClick={() => this.setState({ acceptProduct: product })}
                                >
                                  ПРИНЯТЬ ТОВАР
                                </DefaultButton>
                              ) : (
                                <>
                                  <span className="status_cell_text">
                                    <StatusDot color={getPositionStatusColor(product.position_status)} />
                                    {product.position_status}
                                  </span>
                                  {product.dispatch_ids && product.dispatch_ids.length > 0 && (
                                    <span className="status_cell_links">
                                      {product.dispatch_ids.map(dispatchId => (
                                        <Link
                                          key={dispatchId}
                                          to={`/admin/return-dispatch/${dispatchId}?highlightRefundRequest=${refund_request.id}&highlightArticle=${encodeURIComponent(product.article_number)}&highlightOrder=${product.ordernum}`}
                                          className="related_link_icon"
                                        >
                                          <OpenInNewIcon style={{ fontSize: 16, color: '#0253B3' }} />
                                        </Link>
                                      ))}
                                    </span>
                                  )}
                                  {STICKER_POSITION_STATUSES.includes(product.position_status) && (
                                    <AcceptProductStickerPrintButton product={product} />
                                  )}
                                </>
                              )}
                            </div>
                          </td>
                        )}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
            </div>
            <div className="line_wrapper" />
            <div className="title_items">Комментарии</div>
            {!!refund_request && refund_request.messages && refund_request.messages.length ? (
              <div className="flex flex-column gap-20">
                {refund_request.messages
                  .filter(msg => !msg.parent_message_id)
                  .sort((a, b) => a.pub_date.localeCompare(b.pub_date))
                  .map((parentMsg) => (
                    <div key={parentMsg.id} className="comment-thread">
                      <CommentComponent
                        data={parentMsg}
                        onFileClick={this.downloadFile}
                        action={
                          <Button
                            onClick={() => this.setState({ [`showReplyForm_${parentMsg.id}`]: !this.state[`showReplyForm_${parentMsg.id}`] })}
                            disableRipple={true}
                            classes={{ root: 'reply_btn' }}
                          >
                            {this.state[`showReplyForm_${parentMsg.id}`] ? 'Скрыть' : 'Ответить'}
                          </Button>
                        }
                      />
                      <div className="ml-30">
                        {refund_request.messages
                          .filter(msg => msg.parent_message_id === parentMsg.id)
                          .sort((a, b) => a.pub_date.localeCompare(b.pub_date))
                          .map((childMsg) => (
                            <div className="mt-10">
                              <CommentComponent data={childMsg} key={childMsg.id} onFileClick={this.downloadFile} />
                            </div>
                          ))}
                      </div>
                      <div className="mt-10 ml-30">
                        {this.state[`showReplyForm_${parentMsg.id}`] && (
                          <div>
                            <TextareaAutosize
                              className="mt-10"
                              placeholder="Ваше сообщение..."
                              value={this.state[`reply_${parentMsg.id}`] || ''}
                              onChange={e => this.setState({ [`reply_${parentMsg.id}`]: e.target.value })}
                            />
                            <div className="flex mt-10 gap-20">
                              <DefaultButton
                                variant="outlined"
                                classes="default_button_contained"
                                loading={this.state[`sendLoading_${parentMsg.id}`]}
                                disabled={!(this.state[`reply_${parentMsg.id}`] && this.state[`reply_${parentMsg.id}`].trim())}
                                onClick={() => {
                                  this.sendMessage(
                                    this.state[`reply_${parentMsg.id}`],
                                    this.state[`replyFiles_${parentMsg.id}`] || null,
                                    parentMsg.id,
                                    `sendLoading_${parentMsg.id}`
                                  );
                                }}
                              >
                                Ответить
                              </DefaultButton>
                              <UploadFile
                                uploadFile={files => this.setState({ [`replyFiles_${parentMsg.id}`]: files })}
                                isSending={this.state[`sendLoading_${parentMsg.id}`]}
                                inputId={`files_reply_${parentMsg.id}`}
                              />
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  ))}
              </div>
            ) : null}
            <div className="title_items">Новый комментарий для всех</div>
            <TextareaAutosize
              placeholder="Ваше сообщение..."
              value={message}
              onChange={this.handleChangeTextarea}
            />
            <div className="flex mt-20 gap-20">
              <DefaultButton
                variant="outlined"
                classes="default_button_contained"
                loading={sendMessageLoading}
                disabled={!message}
                onClick={() => this.sendMessage()}
              >
                Ответить
              </DefaultButton>
              <UploadFile
                uploadFile={this.uploadFile}
                isSending={sendMessageLoading}
              />
            </div>
          </div>
          {refund_request.status === "processing" &&
          refund_request.other_requests &&
          refund_request.other_requests.length > 0 ? (
            <div className="item_page_block">
              <div className="refund_requests_page_block">
                <div className="title_items">Другие заявки по заказу</div>
                <div className="item_page_table">
                  <div className="transactions_table">
                    <div className="table_container transactions_columns">
                      <div className="table_header">
                        <div className="table_row">
                          <div className="row_item">Дата/время</div>
                          <div className="row_item">К-во товара</div>
                          <div className="row_item">Заказы</div>
                          <div className="row_item">Сумма</div>
                          <div className="row_item">Статус</div>
                        </div>
                      </div>
                      <div className="table_body">
                        {refund_request.other_requests.map(
                          (request, idRequest) => (
                            <div className="table_row" key={idRequest}>
                              <div className="row_item">
                                {moment(request.date).format(
                                  "DD.MM.YYYY HH:mm"
                                )}
                              </div>
                              <div className="row_item">{request.amount}</div>
                              <div className="row_item">
                                {Array.isArray(request.orders) ? request.orders.join(', ') : request.orders}
                              </div>
                              <div className="row_item">
                                {formatPrice(request.price)}
                              </div>
                              <div className="row_item">
                                <div className="block_status_info">
                                  <span
                                    className="status"
                                    style={{
                                      background: `${getStatusColor(
                                        request.status
                                      )}`,
                                    }}
                                  />
                                  <span className="text">
                                    {getStatusRefundRequest(request.status)}
                                  </span>
                                </div>
                              </div>
                            </div>
                          )
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ) : null}

          <DialogComponent open={open} onClose={this.toggleDialog}>
            <div className="title-dialog">Отказать по заявке на возврат</div>
            <div className="descriptions_dialog_component">Вы уверены?</div>

            <div className="btn-wrapper order-dialog-btn">
              <DefaultButton
                variant="outlined"
                classes="cancel_btn"
                onClick={this.toggleDialog}
              >
                Отмена
              </DefaultButton>
              <DefaultButton onClick={() => this.handleDialog("denied")}>
                Отказать
              </DefaultButton>
            </div>
            <IconButton
              classes={{
                root: "dialog_close_button",
              }}
              onClick={this.toggleDialog}
            >
              <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
          </DialogComponent>
          <DialogComponent open={openDialog} onClose={this.toggleDialogOpen}>
            {refund_request && companyRole !== 'wholesale_customer' ? (
              <RefundRequestsStatusForm
              requestId={refund_request.id}
              toggleDialogOpen={this.toggleDialogOpen}
              handleDialog={this.handleDialog}
              loading={loadingBtn}
              />
            ) : (
              <RefundRequestsStatusWholesaleForm
                requestId={refund_request.id}
                toggleDialogOpen={this.toggleDialogOpen}
                handleDialog={this.handleDialog}
                loading={loadingBtn}
               />
            )}
            
            <IconButton
              classes={{
                root: "dialog_close_button",
              }}
              onClick={this.toggleDialogOpen}
            >
              <img src={CloseDialogIcon} alt="close icon" />
            </IconButton>
          </DialogComponent>
          <AcceptProductDialog
            open={!!this.state.acceptProduct}
            product={this.state.acceptProduct}
            onClose={() => this.setState({ acceptProduct: null })}
            onAccepted={this.doRequest}
          />
        </div>
      </TransitionedBlock>
    );
  }
}

const mapStateToProps = ({ refund_requests }) => ({
  refund_requests,
});

const mapDispatchToProps = {
  getSpecificRefundRequest,
  patchRefundRequestStatus,
  postRefundRequestConfirmStatus,
  postRefundRequestOffers,
  postDialogMessage,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withUploadFile(RefundRequestsItems));
